import { createStore, applyMiddleware, compose, Action } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk, { ThunkAction } from "redux-thunk";
import { DEVELOPMENT } from "Constants/env";
import config from "config";

import { rootReducer } from "../reducers";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const f = config.env === DEVELOPMENT ? composeWithDevTools : compose;

// @ts-ignore
const store = f(applyMiddleware(thunk))(createStore)(rootReducer);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
